import React from 'react';
import { Drawer, List, ListItem, ListItemText, Toolbar, AppBar, Typography, Box, CssBaseline, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import TuneIcon from '@mui/icons-material/Tune';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import PeopleIcon from '@mui/icons-material/People';
import CampaignIcon from '@mui/icons-material/Campaign';

const drawerWidth = 210;

const SidebarLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { text: 'QQ音乐评论统计', path: '/dashboard', icon: <MusicNoteIcon /> },
    { text: '发送规则配置', path: '/qqmusic-config', icon: <TuneIcon />, adminOnly: true },
    { text: '评论文案管理', path: '/copy-texts', icon: <TextFieldsIcon />, adminOnly: true },
    { text: '公告管理', path: '/announcements', icon: <CampaignIcon />, adminOnly: true },
    // 总控架构下暂未接入会话写入，先隐藏
    // { text: '操作记录', path: '/use-records', icon: <HistoryIcon /> },
    { text: '用户管理', path: '/users', icon: <PeopleIcon />, adminOnly: true },
  ];

  const filteredMenuItems = menuItems.filter(item => {
    if (item.adminOnly) return user?.role === 'admin';
    return true;
  });

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: 1201 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" noWrap component="div">QQ音乐评论后台</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {user && <Typography variant="body1" sx={{ mr: 2 }}>{user.username}</Typography>}
            <Button color="inherit" onClick={logout} size="small" variant="outlined">退出</Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" sx={{ width: 0, flexShrink: 0, [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' } }}>
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {filteredMenuItems.map((item) => {
              const selected = location.pathname === item.path;
              return (
                <ListItem key={item.path} button selected={selected} onClick={() => navigate(item.path)}
                  sx={{ my: 0.5, px: 2, minHeight: 44, ...(selected ? { bgcolor: 'action.selected', color: 'primary.main', borderRight: '4px solid', borderRightColor: 'primary.main', fontWeight: 'bold' } : {}) }}>
                  {item.icon}
                  <ListItemText primary={item.text} primaryTypographyProps={{ color: selected ? 'primary.main' : 'text.primary', fontWeight: selected ? 'bold' : 'normal' }} />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3, ml: `${drawerWidth}px`, minWidth: 0 }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default SidebarLayout;
